import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVendorPostingGroup } from "src/models/General/VendorPostingGroup.models";

interface vendorPostingGroupstate {
  vendorPostingGroups: IVendorPostingGroup[];
  vendorPostingGroupToEdit: IVendorPostingGroup | null;
}

const initialState: vendorPostingGroupstate = {
  vendorPostingGroups: [],
  vendorPostingGroupToEdit: null,
};

const vendorPostingGroupSlice = createSlice({
  name: "VendorPostingGroup",
  initialState,
  reducers: {
    setVendorPostingGroupList: (
      state,
      action: PayloadAction<IVendorPostingGroup[]>
    ) => {
      state.vendorPostingGroups = action.payload;
    },
    concatListVendorPostingGroup: (
      state: vendorPostingGroupstate,
      action: PayloadAction<IVendorPostingGroup[]>
    ) => {
      state.vendorPostingGroups = [
        ...state.vendorPostingGroups.concat(action.payload),
      ];
    },
    setVendorPostingGroupToEdit: (
      state,
      action: PayloadAction<IVendorPostingGroup | null>
    ) => {
      state.vendorPostingGroupToEdit = action.payload;
    },
    addVendorPostingGroup: (
      state,
      action: PayloadAction<IVendorPostingGroup>
    ) => {
      state.vendorPostingGroups.push(action.payload);
    },
    updateVendorPostingGroup: (
      state,
      action: PayloadAction<IVendorPostingGroup>
    ) => {
      let itemIndex = state.vendorPostingGroups.findIndex(
        item =>
          item.vendorPostingGroupId === action.payload.vendorPostingGroupId
      );
      if (itemIndex !== -1)
        state.vendorPostingGroups[itemIndex] = action.payload;
    },
    deleteVendorPostingGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.vendorPostingGroups.filter(
        item => item.vendorPostingGroupId !== action.payload
      );
      state.vendorPostingGroups = newArray;
    },
  },
});

export const {
  setVendorPostingGroupList,
  concatListVendorPostingGroup,
  setVendorPostingGroupToEdit,
  addVendorPostingGroup,
  updateVendorPostingGroup,
  deleteVendorPostingGroup,
} = vendorPostingGroupSlice.actions;

export default vendorPostingGroupSlice.reducer;
